/**
 * Shared: Modules > Event Slider
 *
 * @copyright 2024 i-fabrik GmbH
 * @author Tobias Garz
 */

import {extend} from '../../../shared/utils/index';
import {
	isElement,
	isString
}               from '../../../shared/utils/is';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from "../../../shared/dom/manipulator";
import Data from '../../../shared/dom/data';
import Slider from '../../../shared/components/slider/slider';

// -------
// Private
// -------

const NAME      = 'event-group';
const DATA_KEY  = `ifab.${NAME}`;
// const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY   = `.data-api`;

const DEFAULTS = {
	default          : {
		autoHeight: true,
		scrollbar : {
			draggable    : true,
			snapOnRelease: true
		}
	},
	timeonly             : {
		autoHeight : true
	},
	guestperformances: {
		autoHeight: false,
		scrollbar : {
			draggable    : true,
			snapOnRelease: true
		}
	}
};

const renderSlider = (element, o) => {
	Slider.init(element, o);
};

/**
 * ´Event Slider´-Element initialisieren.
 *
 * @param {HTMLElement} element
 * @param {Object} o
 * @returns {HTMLElement}
 */
const render = (element, o) => {
	// Wurde Element schon initialisiert?
	if (Data.get(element, `${DATA_KEY}.initialized`)) {
		return element;
	}

	const slider = SelectorEngine.findOne(`[data-c="slider-${NAME}"]`, element);

	if (slider) {
		renderSlider(slider, extend({}, {
			slidesPerView: 'auto',
			spaceBetween : 0
		}, o));
	}

	// Initialisierungsstatus setzen.
	Data.set(element, `${DATA_KEY}.initialized`, true);

	return element;
};

// -------
// Public
// -------

/**
 * ´Event Slider´-Elemente zusammenstellen und initialisieren.
 *
 * @param {HTMLElement|String|null} [m=null]
 * @param {Object} [o={}]
 * @returns {HTMLElement|Array}
 */

document.addEventListener('DOMContentLoaded', function(event) {
	let group;
	let view = 'default';

	const collection = SelectorEngine.find(`[data-c="${NAME}"]`, document.documentElement);

	group = [];

	for (const element of collection) {
		view = Manipulator.getDataAttribute(element, 'view');

		const _o = DEFAULTS[view];

		if(_o.scrollbar) {
			_o.scrollbar.el = SelectorEngine.findOne('.swiper-scrollbar', element);
		}

		group.push(render(element, _o));
	}
	return group;
});